import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import V2Layout from '../components/V2Layout'
import SEO from '../components/SEO'
import axios from 'axios'

const API = ''

function formatDate(d) {
    if (!d) return ''
    return new Date(d + 'Z').toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
}

function stripHtml(html) {
    if (!html) return ''
    return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
}

const NewsArticleScreen = () => {
    const { id } = useParams()
    const [article, setArticle] = useState(null)

    useEffect(() => {
        axios.get(`${API}/api/news/${id}`).then(r => setArticle(r.data)).catch(() => { })
    }, [id])

    if (!article) return (
        <V2Layout><Container style={{ padding: '4rem 0', textAlign: 'center' }}><p style={{ color: 'var(--v2-text3)' }}>Loading...</p></Container></V2Layout>
    )

    return (
        <V2Layout pageClass="pfc-news-detail">
            <SEO
                title={article.title}
                description={stripHtml(article.body).slice(0, 160)}
            />
            <section className="pfc-page-hero">
                <div className="pfc-page-hero-inner">
                    <p className="v2-section-label">{formatDate(article.created_at)}</p>
                    <h1 className="pfc-page-hero-title">{article.title}</h1>
                    <div style={{ marginTop: '1.5rem' }}>
                        <Link to="/news" className="v2-btn-outline" style={{ textTransform: 'uppercase', fontSize: '12px', letterSpacing: '0.05em', textDecoration: 'none' }}>
                            ← Back to News
                        </Link>
                    </div>
                </div>
            </section>

            <section className="v2-content" style={{ padding: '4rem 0 6rem', minHeight: '60vh' }}>
                <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 24px' }}>
                    {article.header_image && (
                        <div style={{ marginBottom: '2.5rem', borderRadius: '8px', overflow: 'hidden', border: '1px solid var(--v2-border)', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                            <img src={`${API}${article.header_image}`} alt={article.title} style={{ width: '100%', maxHeight: '500px', objectFit: 'cover' }} />
                        </div>
                    )}
                    <div className="v2-content-body" style={{ fontSize: '1.125rem', lineHeight: 1.8, color: 'var(--v2-text)' }} dangerouslySetInnerHTML={{ __html: article.body }} />
                </div>
            </section>
        </V2Layout>
    )
}

export default NewsArticleScreen
